import React from 'react';
import styled from 'styled-components';
import { useEditMode } from '../../shared/hooks/useEditMode';
import { TextTagData } from '../../shared/dto/EntityRepository';
import { useTextViewStore } from '../../shared/store/TextViewStore';

interface TextTagInViewerProps {
  tag: TextTagData;
}

const TextTagInViewer: React.FC<TextTagInViewerProps> = ({ tag }) => {
  const { isEditMode } = useEditMode();
  const activeText = useTextViewStore((s) => s.activeText);
  const updateActiveText = useTextViewStore((s) => s.updateActiveText);
  if (!activeText) return null;

  const currentTags = activeText.tags ?? [];
  const isOnText = currentTags.some((t) => t.id === tag.id);

  if (!isEditMode && !isOnText) return null;

  const handleToggle = () => {
    if (!isEditMode) {
      return;
    }
    const nextTags = isOnText
      ? currentTags.filter((t) => t.id !== tag.id)
      : [...currentTags, tag];
    updateActiveText({ tags: nextTags });
  };

  return (
    <TagItem $isActive={isOnText} $isEditMode={isEditMode} onClick={handleToggle}>
      {tag.name}
    </TagItem>
  );
};

const TagItem = styled.div<{ $isActive: boolean, $isEditMode: boolean }>`
  width: fit-content;
  border-bottom: 1px dotted
    ${({ $isActive, theme }) => ($isActive ? theme.colors.color_Gray_03 : 'transparent')};
  color: ${({ $isActive, theme }) => ($isActive ? theme.colors.color_Gray_03 : theme.colors.color_Gray_04)};
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.5)};
  &:hover {
    ${({ $isEditMode }) => $isEditMode ? 'transform: scale(0.95);' : ''}
  }
  transition: all 0.3s ease-in-out;
  cursor: ${({ $isEditMode }) => $isEditMode ? 'pointer' : 'default'};
`;

export default TextTagInViewer;
